import { formatInTimeZone } from 'date-fns-tz'
import { EMPTY_VALUE } from '../config'

export function formatCost(usd: number | null | undefined): string {
  if (usd === null || usd === undefined) return EMPTY_VALUE
  return `$${usd.toFixed(usd < 1 ? 3 : 2)}`
}

export function formatLatency(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return EMPTY_VALUE
  if (ms < 1000) return `${Math.round(ms)} ms`
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)} s`
  const minutes = Math.floor(ms / 60_000)
  const seconds = Math.round((ms % 60_000) / 1000)
  return `${minutes} min ${seconds} s`
}

export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined) return EMPTY_VALUE
  return value.toLocaleString('en-US')
}

export function formatTimestamp(iso: string | null | undefined): string {
  if (!iso) return EMPTY_VALUE
  try {
    return formatInTimeZone(iso, 'UTC', "dd MMM yyyy, HH:mm 'UTC'")
  } catch {
    return iso
  }
}
